// Skróty plików (SHA-256, 64 znaki szesnastkowe), na które wskazują zdarzenia: plany, zdjęcia, podpisy, LV, protokoły.
const SKROT = /^[0-9a-f]{64}$/;
export const czySkrot = (s) => typeof s === 'string' && SKROT.test(s);
export function skrotyPlikow(zdarzenia) {
  const H = new Set(); const idz = (v) => { if (typeof v === 'string') { if (SKROT.test(v)) H.add(v); } else if (Array.isArray(v)) v.forEach(idz); else if (v && typeof v === 'object') Object.values(v).forEach(idz); };
  for (const z of zdarzenia) idz(z.dane); return [...H];
}
